// 落地页结果页 多语言
import React, { useState, useEffect } from 'react';
import Image from 'next/image';
import cls from 'classnames';
import { Button, Loading as LoadingModal, apis } from '@wukong/haomao';
import styles from './style.module.scss';
// 中文title图片
import TitleInfoImg from '../../../../public/images/landing-result/title-info-v2.png';
import TitleInfoEnImg from '../../../../public/images/landing-result/title-info-en-v2.png';
// 课程图片中文
import CoursePictureImg from '../../../../public/images/landing-result/course-picture-v2.png';
import CoursePictureEnImg from '../../../../public/images/landing-result/course-picture-v2-en.png';
import lowerDecorationImg from '../../../../public/images/landing-result/lower-decoration-v2.png';
import maskIcon2Img from '../../../../public/images/landing-result/mask-icon-2.png';
import maskIcon5Img from '../../../../public/images/landing-result/icon-5.png';
import { isWechatEnvironment, isMobile } from '../../../utils/helpers';
import { QR_CODE_CHINESE, QR_CODE_MATH, LANDING_RESULT_EN, LANDING_RESULT_ZH } from '../../../utils/constants';
// 可以传入 图片 赠送课程名称 赠送课程文案 领取文案 领取提示文案
// 默认的文案

interface ResultMultilingualProps {
  // 弹窗隐藏展示
  visible?: boolean;
  // 企微二维码
  WXCodeUrl?: string;
  // 语言 默认中文 因为页面有纯中文 纯英文 多语言情况 所有没有使用i18n en zh
  lang?: string;
  // title图片
  titleInfoImgProps?: any;
  // 课程图片
  coursePictureImgProps?: any;
  coursePictureImgEnProps?: any;
  // 课程名称
  courseName?: string;
  // 弹窗标题
  modelTitle?: string;
  // 长按二维码文案
  pickUpReminderLongPress?: string;
  // 扫码二维码文案
  ScanningReminderLongPress?: string;
  // 按钮点击领取提醒文案
  pickUpReminder?: string;
  // 按钮文案
  btnPickUp?: string;
  // 科目 默认中文 chinese math
  subject?: string;
}
const LandingResultMultilingual = ({
  visible,
  WXCodeUrl,
  lang = 'zh',
  titleInfoImgProps,
  coursePictureImgProps = CoursePictureImg,
  coursePictureImgEnProps = CoursePictureEnImg,
  courseName,
  modelTitle,
  pickUpReminderLongPress,
  ScanningReminderLongPress,
  pickUpReminder,
  btnPickUp,
  subject = 'chinese',
}: ResultMultilingualProps) => {
  // 按钮样式 不是微信环境 并且 移动端
  // 二维码样式 pc端 或则 微信环境
  // 默认二维码
  const [isCodeType, setIsCodeType] = useState(true);
  // 二维码图片
  const [newWXCodeUrl, setNewWXCodeUrl] = useState(WXCodeUrl);
  const [mobile, setMobile] = useState(false);
  const [langText, setLangText] = useState(LANDING_RESULT_ZH);

  useEffect(() => {
    // 判断不是微信环境 并且 是移动端
    if (!isWechatEnvironment() && isMobile()) {
      setIsCodeType(false);
    }
    // 判断是否是移动端
    if (isMobile()) {
      setMobile(true);
    }
    // 如果WXCodeUrl没有值 则中文和数学使用各自默认二维码
    if (WXCodeUrl?.length === 0) {
      if (subject === 'math') {
        setNewWXCodeUrl(QR_CODE_MATH);
      } else {
        setNewWXCodeUrl(QR_CODE_CHINESE);
      }
    }
    if (lang === 'en') {
      setLangText(LANDING_RESULT_EN);
    }
  }, []);

  useEffect(() => {
    if (WXCodeUrl) {
      setNewWXCodeUrl(WXCodeUrl);
    } else if (WXCodeUrl?.length === 0) {
      if (subject === 'math') {
        setNewWXCodeUrl(QR_CODE_MATH);
      } else {
        setNewWXCodeUrl(QR_CODE_CHINESE);
      }
    }
  }, [WXCodeUrl]);

  const handleGet = () => {
    LoadingModal.show('Loading...');
    // 转换为小程序的语言标识
    const newLang = lang === 'en' ? 'en_US' : 'zh_CN';
    const params = {
      path: '/packageA/pages/enterprise-micro/index',
      query: `lang=${newLang}&WXCodeUrl=${newWXCodeUrl}`,
    };
    apis
      .getGenerateScheme(params)
      .then((res) => {
        window.location.href = res.content;
      })
      .finally(() => {
        LoadingModal.hide();
      });
  };

  return (
    <div
      className={cls(styles.mask, {
        [styles.hide]: !visible,
      })}
    >
      <div
        className={cls(styles.container, {
          [styles.localeEn]: lang === 'en',
        })}
      >
        <div className={styles.titleInfo}>
          <Image
            layout="responsive"
            priority
            src={titleInfoImgProps || (lang === 'en' ? TitleInfoEnImg : TitleInfoImg)}
            alt=""
            placeholder="blur"
          />
        </div>
        <div className={styles.maskIcon2}>
          <Image layout="responsive" priority src={maskIcon2Img} alt="" placeholder="blur" />
        </div>
        <div className={styles.title}>
          <div className={styles.titleText}>{modelTitle || langText.modelTitle}</div>
        </div>
        <div className={styles.courseName}>
          <span className={styles.courseNameIconLeft} />
          <span className={styles.courseNameInner}>{courseName || langText.modelCourseName}</span>
          <span className={styles.courseNameIconRight} />
        </div>
        <div className={styles.coursePicture}>
          <Image
            layout="responsive"
            priority
            src={lang === 'en' ? coursePictureImgEnProps : coursePictureImgProps}
            alt=""
          />
        </div>
        {isCodeType && (
          <div className={styles.icon5Box}>
            <Image layout="responsive" priority src={maskIcon5Img} alt="" placeholder="blur" />
          </div>
        )}
        {isCodeType && (
          <div className={styles.codeBox}>
            <img className={styles.codeImg} alt="" src={newWXCodeUrl} />
          </div>
        )}
        {isCodeType && (
          <div
            className={styles.pickUpReminderLongPress}
            dangerouslySetInnerHTML={{
              __html: mobile
                ? pickUpReminderLongPress || langText.pickUpReminderLongPress
                : ScanningReminderLongPress || langText.ScanningReminderLongPress,
            }}
          />
        )}
        {!isCodeType && (
          <div>
            <Button block className={styles.btn} onClick={handleGet}>
              <span className={styles.wxIcon} />
              <span className={styles.hand} />
              <span className={styles.timeLimit} />
              {/* <span className={styles.wxIcon} /> */}
              {btnPickUp || langText.btnPickUp}
            </Button>
          </div>
        )}
        {!isCodeType && (
          <div
            className={styles.pickUpReminder}
            dangerouslySetInnerHTML={{ __html: pickUpReminder || langText.pickUpReminder }}
          />
        )}
        <div className={styles.lowerDecoration}>
          <Image layout="responsive" priority src={lowerDecorationImg} alt="" placeholder="blur" />
        </div>
      </div>
    </div>
  );
};
export default LandingResultMultilingual;
